module.exports = __webpack_public_path__ + "img/mapa.02aa1d63.png";